import styled, {css} from "styled-components";

export const ChoiceGroupWrap = styled.div`
    background-color: ${({theme}) => theme?.light?.primary50};
    border-radius: 15px;
    padding: 15px;
    margin-bottom: 30px;
    .text-wrap {
        @media (min-width: 768px) {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .left-content {
            margin-bottom: 20px;

            @media (min-width: 992px) {
                margin-bottom: 0;
            }

            .heading {
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                @media (min-width: 768px) {
                    font-size: 18px;
                    line-height: 22px;
                }
                margin-bottom: 20px;
                strong {
                    display: block;
                    margin-bottom: 10px;
                }
            }
            form > div > div {
                max-width: 300px;
            }
        }
        .right-content {
            button {
                width: 220px;
            }
        }
    }
`;
export const ChoiceWrapper = styled.div`
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    background-color: var(--white);
    border-radius: 10px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
    margin-bottom: 20px;
    padding: 20px;
    display: none;
    @media (min-width: 600px) {
        font-size: 16px;
        line-height: 20px;
    }

    ${({$category}) =>
        $category &&
        css`
            padding: 10px 20px;
            box-shadow: none;
            background-color: #f0f2f3;
            margin: 0 0 15px;
            strong {
                font-weight: 500;
            }
        `}

    strong {
        @media (max-width: 600px) {
            display: block;
            margin-bottom: 10px;
        }
        position: relative;
        &.available::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #289a00;
        }
        &.unavailable::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #e00000;
        }
        padding-left: 20px;
        &:first-child {
            padding-left: 10px;
        }
    }
    @media (min-width: 992px) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 0.3fr;
    }
`;
